import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { UserContext } from "../context/UserContext";

import Unauthorized from "../pages/error/Unauthorized";

const PrivateRoute = ({ children, allowedRoles = [] }) => {
    const { user, initialLoad } = useContext(UserContext);
    const location = useLocation();

    if (initialLoad) {
        return (
            <div className="loader center">
                <i className="fa fa-cog fa-spin"/>
            </div>
        );
    }

    // Not logged in redirect
    if (!user) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    // If allowedRoles is specified, check role
    if (allowedRoles.length > 0 && !allowedRoles.includes(user.roleId)) {
        return <Unauthorized/>;
    }

    return children;
};

export default PrivateRoute;